import Contact from "./Contact";
import Contract from "./Contract";
import Location from "./Location";
import PersonalInfos from "./PersonalInfos";
import ProfessionalInfos from "./ProfessionalInfos";

const ProfileFormSections = {
  Contact,
  Location,
  Contract,
  PersonalInfos,
  ProfessionalInfos,
};


export default ProfileFormSections;